/* global google */
import { Loader } from '@googlemaps/js-api-loader';

class GoogleStreetviewAPIWrapper {
  constructor() {
    this.cache = {};
    this.streetViewService = null;
  }

  getStreetViewService = () => {
    this.streetViewService = this.streetViewService || new google.maps.StreetViewService();
    return this.streetViewService;
  };

  fetchPanorama = async coords => {
    const loader = new Loader({ apiKey: globalThis.mapsApiKey });
    const google = await loader.load();

    return new Promise((resolve, reject) => {
      if (!coords) return resolve(null);

      const cached = this.cache[JSON.stringify(coords)];
      if (cached) return resolve(cached);

      const googleCoords = new google.maps.LatLng(coords.lat, coords.lng);
      const processResult = (data, status) => {
        if (status !== google.maps.StreetViewStatus.OK) return reject();

        // retrieve the panorama ID and the latLng of the panorama
        const { pano, latLng } = data.location;
        // calculate the heading between the panorama and our address
        const heading = google.maps.geometry.spherical.computeHeading(latLng, googleCoords);

        const newState = { pano, heading };
        this.cache[JSON.stringify(coords)] = newState;
        resolve(newState);
      };
      const request = {
        source: google.maps.StreetViewSource.OUTDOOR,
        location: googleCoords
      };
      this.getStreetViewService().getPanorama(request, processResult);
    });
  };
}

let instance = null;
GoogleStreetviewAPIWrapper.getInstance = () => {
  instance = instance || new GoogleStreetviewAPIWrapper();
  return instance;
};

export default GoogleStreetviewAPIWrapper;
